import CreditRewardPage from './CreditRewardPage'
export default CreditRewardPage;